exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Avatar-module__wrapper___15Jzt{width:-moz-max-content;width:max-content;outline:none}.Avatar-module__wrapper___15Jzt,.Avatar-module__wrapper___15Jzt .Avatar-module__tile___1o2vS{position:relative;height:100%}.Avatar-module__wrapper___15Jzt .Avatar-module__tile___1o2vS{z-index:1;display:grid}.Avatar-module__wrapper___15Jzt img{grid-area:1/1/1/1;align-self:end;width:226px}", ""]);

// exports
exports.locals = {
	"wrapper": "Avatar-module__wrapper___15Jzt",
	"tile": "Avatar-module__tile___1o2vS"
};